import { extendTheme } from '@chakra-ui/react';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  BG_SECONDARY_TRANSPARENT,
  BG_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_PRIMARY_LIGHT,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: `"Poppins", sans-serif;`,
    subHeading: `"Poppins", sans-serif;`,
    body: `"Poppins", sans-serif;`,
    body_lv2: `"Poppins", sans-serif;`,
    fullName: `"Poppins", sans-serif;`,
    jost: `'Jost', serif`,
  },
  fontSizes: {
    heading: '26px',
    subHeading: '18px',
    body: '16px',
    body_lv2: '16px',
    fullName: '18px',
  },
  fontWeights: {
    heading: 600,
    subHeading: 500,
    body: 300,
    body_lv2: 300,
    fullName: 600,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-body_lv2': '',
        '--fontItalic-fullName': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(0,0,2,1)',
    bgSecondary: '#d0aa6aff',
    bgAlternative: 'rgba(251,244,156,1)',
    mainColorText: 'rgba(255,255,255,1)',
    secondaryColorText: 'rgba(0,0,2,1)',
    mainColorTextLight: 'rgba(1,0,6,1)',

    button: {
      secondary: {
        500: BG_SECONDARY,
      },
      secondaryDark: {
        500: BG_ALTERNATIVE,
      },
    },
  },
  shadows: {
    outline: BG_ALTERNATIVE,
  },
};

export default extendTheme(theme);
